module.exports = __webpack_public_path__ + "img/ring_r_l_1_null@2x.7ee2833d.png";